export const SET_ASSET_PURCHASER_ACQUISITION_EXPENSES = "SET_ASSET_PURCHASER_ACQUISITION_EXPENSES"
export const SET_STOCK_PURCHASER_ACQUISITION_EXPENSES = "SET_STOCK_PURCHASER_ACQUISITION_EXPENSES"
